<template>
    <div>
        <Dashboard></Dashboard>
        <Notifications></Notifications>
    </div>
</template>

<script>
    import Dashboard from "../components/Dashboard";
    import Notifications from "../components/Notifications";

    export default {
        name: "dashboard-page",
        components: {
            Dashboard,
            Notifications
        }
    };
</script>